import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, IsActiveMatchOptions } from '@angular/router';
import { filter } from 'rxjs/operators';
import { coreConfig } from 'app/app-config';
import { ParametreService } from './parametre.service';
import {HeaderService} from "../../../services/header/header.service";
import { LogicielCaisseModuleService } from '../../../services/logiciel-caisse/logiciel-caisse-module.service';
import { LogicielCaisseAuthService } from '../../../services/logiciel-caisse/logiciel-caisse-auth.service';
import { ParametreNavService } from '../../../services/parametre/parametre-nav.service';

@Component({
  selector: 'app-main-parametre',
  templateUrl: './main-parametre.component.html',
  styleUrls: ['./main-parametre.component.scss'],
  host: { class: 'email-application' }
})
export class MainParametreComponent implements OnInit {
  @ViewChild('contentWrapper') contentWrapper: ElementRef;
  animation = 'fadeIn';
  numArray: number[] = [];
  page: string = 'p-e';
  private currentRoute: string;

  /**
   * Garde le surlignage du sous-menu (ex. Produits) lors des changements d’onglet
   * ?tab=import, ?tab=champs, etc. — sans ça, exact: true comparait aussi les query params.
   */
  readonly donneesSubLinkActiveOptions: IsActiveMatchOptions = {
    paths: 'exact',
    queryParams: 'ignored',
    fragment: 'ignored',
    matrixParams: 'ignored'
  };

  /** Surligne « Configuration caisse » sur /logiciel-caisse et /logiciel-caisse/wizard. */
  readonly lcDashboardLinkActiveOptions: IsActiveMatchOptions = {
    paths: 'subset',
    queryParams: 'ignored',
    fragment: 'ignored',
    matrixParams: 'ignored'
  };

  /**
   * Sur /main/parametre/donnees/** : sidebar limitée au sous-menu données uniquement
   * (les autres entrées passent par l’icône engrenage de la barre).
   */
  showParametreDonneesNav = false;

  /** Affiché seulement si le module logiciel caisse est activé pour la station. */
  showLogicielCaisseNav = false;

  paramNavLoading = false;

  constructor(
    private headerService: HeaderService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private parametreService: ParametreService,
    private readonly lcModuleService: LogicielCaisseModuleService,
    private readonly lcAuthService: LogicielCaisseAuthService,
    private readonly parametreNavService: ParametreNavService
  ) {}

  private setParametreDonneesNavVisibility(url: string): void {
    const u = url || '';
    this.showParametreDonneesNav =
      /\/main\/parametre\/donnees(\/|$)/.test(u) ||
      /\/main\/parametre\/gestion-stock(\/|$)/.test(u);
  }

  private refreshLogicielCaisseNav(): void {
    const ctx = this.lcAuthService.getErpContext();
    if (!ctx) {
      this.showLogicielCaisseNav = false;
      return;
    }
    const effectiveCode = this.lcAuthService.getEffectiveCodeStation(ctx.erpUserId);
    this.showLogicielCaisseNav =
      this.lcModuleService.isEnabled(ctx.code_station) ||
      this.lcModuleService.isEnabled(effectiveCode) ||
      this.lcAuthService.isAuthenticated();
  }

  /** Met à jour le titre du header selon l’URL (ex. navigation depuis le menu engrenage). */
  private syncPageFromUrl(url: string): void {
    const u = url || '';
    if (
      /\/main\/parametre\/donnees(\/|$)/.test(u) ||
      /\/main\/parametre\/gestion-stock(\/|$)/.test(u)
    ) {
      this.changeActive('p-db');
      return;
    }
    if (u.includes('/main/parametre/taxe-tva')) this.changeActive('t-tva');
    else if (u.includes('/main/parametre/entreprise')) this.changeActive('p-e');
    else if (u.includes('/main/parametre/document')) this.changeActive('p-d');
    else if (u.includes('/main/parametre/compte-bancaire')) this.changeActive('c-b');
    else if (u.includes('/main/parametre/liste-prix')) this.changeActive('l-p');
    else if (u.includes('/main/parametre/comptable-parametre')) this.changeActive('c-p');
    else if (u.includes('/main/parametre/user-and-role')) this.changeActive('u-r');
    else if (u.includes('/main/parametre/integration')) this.changeActive('i-p');
    else if (u.includes('/main/parametre/marque-categorie')) this.changeActive('m-c');
    else if (u.includes('/main/parametre/projets')) this.changeActive('p-j');
    else if (u.includes('/main/parametre/logiciel-caisse')) this.changeActive('lc-dash');
    else if (u.includes('/main/parametre/entrepots')) this.changeActive('lc-e');
    else if (u.includes('/main/parametre/caisses')) this.changeActive('lc-c');
    else if (u.includes('/main/parametre/ticket-templates')) this.changeActive('lc-ttpl');
    else if (u.includes('/main/parametre/modes-paiement')) this.changeActive('lc-mp');
    else if (u.includes('/main/parametre/gerant-entrepot')) this.changeActive('lc-ge');
    else if (u.includes('/main/parametre/vendeur-caisse')) this.changeActive('lc-vc');
    else if (u.includes('/main/parametre/commerciaux')) this.changeActive('lc-commercial');
    else if (u.includes('/main/parametre/etablissements')) this.changeActive('lc-etab');
    else if (u.includes('/main/parametre/reasort')) this.changeActive('lc-reasort');
  }

  ngOnInit(): void {
    this.setParametreDonneesNavVisibility(this.router.url);
    this.refreshLogicielCaisseNav();
    this.syncPageFromUrl(this.router.url);
    this.parametreNavService.loading$.subscribe((loading) => {
      this.paramNavLoading = loading;
    });
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentRoute = event.urlAfterRedirects;
        this.setParametreDonneesNavVisibility(event.urlAfterRedirects);
        this.refreshLogicielCaisseNav();
        this.syncPageFromUrl(event.urlAfterRedirects);
     //   this.updatePageFromRoute();
        const el = this.contentWrapper?.nativeElement;
        if (el) {
          el.classList.remove('animate__fadeIn');
          void el.offsetWidth;
          el.classList.add('animate__fadeIn');
        }
      });

      this.headerService.setConfig({
          title: this.getTitle(this.page),
          buttons: [

          ]
      });
  }

  updatePageFromRoute(): void {
    const url = this.currentRoute || '';

    if (url.includes('/main/parametre/taxe-tva')) {
      this.page = 't-tva';
    } else if (url.includes('/main/parametre/entreprise')) {
      this.page = 'p-e';
    } else if (url.includes('/main/parametre/document')) {
      this.page = 'p-d';
    } else if (url.includes('/main/parametre/compte-bancaire')) {
      this.page = 'c-b';
    } else if (url.includes('/main/parametre/liste-prix')) {
      this.page = 'l-p';
    } else if (url.includes('/main/parametre/comptable-parametre')) {
      this.page = 'c-p';
    } else if (url.includes('/main/parametre/user-and-role')) {
      this.page = 'u-r';
    } else if (url.includes('/main/parametre/integration')) {
      this.page = 'i-p';
    } else if (url.includes('/main/parametre/marque-categorie')) {
      this.page = 'm-c';
    } else if (url.includes('/main/parametre/projets')) {
      this.page = 'p-j';
    } else if (url.includes('/main/parametre/donnees')) {
      this.page = 'p-db';
    } else if (url.includes('/produits/categories')) {
      this.page = 'm-c';
    } else {
      this.page = this.page || 'p-e';
    }
  }

  getTitle(page: string): string {
    const titles = {
      'p-e': 'Profil de l\'entreprise',
      'p-d': 'Paramètres des documents',
      'c-b': 'Compte bancaire',
      't-tva': 'Taxes et TVA',
      'l-p': 'Listes de prix',
      'c-p': 'Comptable',
      'u-r': 'Utilisateurs et rôles',
      'i-p': 'Intégration',
      'p-j': 'Projets',
      'm-c': 'Marques, Catégories et Unités',
      'p-db': 'Paramètres des données',
      'lc-dash': 'Configuration logiciel de caisse',
      'lc-e': 'Entrepôts (logiciel caisse)',
      'lc-c': 'Caisses (logiciel caisse)',
      'lc-ttpl': 'Templates ticket',
      'lc-mp': 'Modes de paiement',
      'lc-ge': 'Gérants et entrepôts',
      'lc-vc': 'Vendeurs et caisses',
      'lc-commercial': 'Commerciaux — entrepôt associé',
      'lc-etab': 'Établissements (logiciel caisse)',
      'lc-reasort': 'Réassort (min/max & priorités)',
    };
    return titles[page] || 'Paramètres';
  }

  showAddButton(page: string): boolean {
    return ['t-tva', 'l-p', 'u-r', 'i-p', 'm-c'].includes(page);
  }
  
handleAddAction(page: string): void {
  console.log('handleAddAction called for page:', page); // Debug log
  switch (page) {
    case 't-tva':
      console.log('Triggering modal for taxe-tva');
      this.parametreService.triggerModal('taxe-tva', 'add', 'taxe'); 
      break;
    case 'l-p':
      console.log('Triggering modal for liste-prix');
      this.parametreService.triggerModal('liste-prix', 'add');
      break;
    case 'u-r':
      this.router.navigate(['/main/parametre/user-and-role/ajouter']);
      break;
    case 'i-p':
      console.log('Triggering modal for integration');
      this.parametreService.triggerModal('integration', 'add');
      break;
    case 'm-c':
      console.log('Triggering modal for marque-categorie');
      this.parametreService.triggerModal('marque-categorie', 'add');
      break;
  }
}

  changeActive(p: string) {
      this.page = p;
      this.headerService.setConfig({
          title: this.getTitle(this.page),
          buttons: [
              // Update buttons if needed
          ]
      });
  }

  prepareRoute(outlet: any) {
    return outlet.activatedRouteData['animation'];
  }
}